import {DynamicSettings} from './settings';
import {LanguageCode} from '../../shared-gen/Model/Localization/LanguageCode';

export class DynamicSettingsFun {

	static createNew(): DynamicSettings {
		return {
			language: LanguageCode.DE
		}
	}

}
